import {createApp} from 'vue'
import XoperoOnePricingForm from "@components/XoperoOnePricingForm.vue";
import Toast from 'vue-toastification'
import "vue-toastification/dist/index.css";

createApp(XoperoOnePricingForm)
    .use(Toast, {})
    .mount('#xopero-one-pricing-form')
